import { serviceMaker, methods, api } from "@/http/index.js";

export const getItems = () => serviceMaker(`/items`, methods.GET, api.NGB);
export const createItems = (data) =>
  serviceMaker(`/items`, methods.POST, api.NGB, data);
export const itemDataTemplate = () =>
  serviceMaker(`/items/template`, methods.GET, api.NGB);
export const getItemById = (id) =>
  serviceMaker(`/items/${id}`, methods.GET, api.NGB);
export const editItem = (id, data) =>
  serviceMaker(`/items/${id}`, methods.PUT, api.NGB, data);
export const removeItem = (id) =>
  serviceMaker(`/items/${id}`, methods.DELETE, api.NGB);
